import { FC } from "react"
import styled from "styled-components"

interface Props {
  total: number
  player: string
  title: string
}

const StatsCard: FC<Props> = ({ total, player, title }) => {
  return (
    <Wrapper>
      <Container>
        <TextContainer>
          <Text className="heading">{title}</Text>
        </TextContainer>
        <StatsContainer>
          <StatText>
            {player} ({total})
          </StatText>
        </StatsContainer>
      </Container>
    </Wrapper>
  )
}

export default StatsCard

const Wrapper = styled.div`
  padding: 0.2rem;
  width: 100%;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  @media (max-width: 1200px) {
  }
  box-shadow: 0 0 4px 1px #00eaff;
  border-radius: 12px;
  border: 2px solid #5fa8e6;
  background: linear-gradient(120deg, #23263a 60%, #1a1c28 100%);
`
const TextContainer = styled.div`
  color: rgba(250, 252, 43, 1);
`
const Text = styled.p`
  padding: 0;
  margin: 0;
  font-weight: 700;
`
const StatsContainer = styled.div`
  width: 100%;
  text-align: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background: linear-gradient(120deg, rgba(35, 38, 58, 0.8) 60%, rgba(26, 28, 40, 0.8) 100%);
`
const StatText = styled.p`
  padding: 0;
  margin: 0;
`
